// Lightweight tracking utilities:
// - appendUTM: adds UTM query params to any URL for attribution
// - trackEvent: fires a Google Analytics 4 event via gtag (no-op if GA isn't installed)
import { safeEventParams } from "./analyticsPrivacy";

export function appendUTM(url, { source = "site", medium = "cta", campaign, content } = {}) {
  if (!url) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("utm_source", source);
    u.searchParams.set("utm_medium", medium);
    if (campaign) u.searchParams.set("utm_campaign", campaign);
    if (content) u.searchParams.set("utm_content", content);
    return u.toString();
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[tracking] appendUTM failed for", url, err);
    }
    return url;
  }
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  try {
    params = safeEventParams(params);
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
    // Also push to dataLayer for GTM if present
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
    }
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[tracking] trackEvent failed", eventName, err);
    }
  }
}
